import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderTelerikReleaseNotes extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
    }

    getItemHtml(item, relatedMedia) {
        const { UrlName: resourcePath } = item;
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        const date = new Date(item.ReleaseDate).toLocaleString('default', options);       
        const html = `
        <li>
             <h2 class="h4 -mb0">
                 <a href="${window.location.pathname}/${resourcePath}">${item.Title}</a></h2>
             <time datetime="${item.ReleaseDate}" class="Text--xs">${date}</time>
   
        </li>
    `;

        return html;
    }
}
